import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import Cookies from 'js-cookie';
import storage from '../../../Storage';
import socket from '../../../Socket';
import { Event, wait, decode, encode, sendNotfication, isEmail, API } from '../../../Helper';
import { useGlassyNotifications } from '../../../Context/GlassyNotificationsContext';
import C from '../../../Constant';
import Google from "./Google";
import { CrossIcon } from 'lucide-react';

const StyledModal = styled(Modal)`
  .modal-content {
    background: #292d2e !important;
    color: white;
    border-radius: 12px;
    overflow: hidden;
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    z-index: 999;
    height: 85vh;
    
    @media (min-width: 768px) {
      flex-direction: row;
    }
    
    @media (max-width: 768px) {
      height: 100%;
      min-height: auto;
      border-radius: 0;
      overflow-y: auto;
    }
  }
  
  .modal-dialog {
    max-width: 900px;
    margin: 0;
    height: 100vh;
    width: 97vw;
    z-index: 9999;
    
    @media (min-width: 768px) {
      margin: 1.75rem auto;
      height: auto;
      width: 97vw;
    }
    
    @media (max-width: 768px) {
      margin: 0;
      width: 100vw;
      max-width: 100%;
      height: 100%;
      top: 0;
      position: fixed;
    }
  }
  
  &.modal {
    // z-index: 9999;
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 0;
    // z-index: 9999;
    
    .modal-content {
      border-radius: 0;
    }
    
    &.modal-dialog-centered {
      min-height: 100vh;
      align-items: flex-start;
    }
  }
`;

const LeftSection = styled(Modal.Body)`
  padding: 32px;
  flex: 1;
  position: relative;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 24px 20px;
    order: 2;
    margin-top: 0;
    background: #292d2e;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const RightSection = styled.div`
  flex: 1;
  background-image: url('/assets/images/bcgames/signup/signup8.png');
  background-size: cover;
  background-position: center;
  position: relative;
  background-repeat:no-repeat;
  
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: space-between;
  padding: 65px 30px;
  object-fit: cover;
  
  @media (min-width: 768px) {
    min-height: 100vh;
    background-position: center top;
    overflow: hidden;
  }
  
  @media (max-width: 768px) {
    order: 1;
    min-height: 250px;
    padding: 30px 16px;
    flex: none;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-position: center top;
    background-size: cover;
    border-radius: 0 0 20px 20px;
  }
`;

const FlipCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  
  margin: 40px auto 0;

  
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileLogo = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
  }
`;
  
const CardImage = styled.img`
  width: 96px;
  height: 96px;
  object-fit: contain;
  flex-shrink: 0;
  transition: transform 0.5s ease-in-out;

  &:hover {
    transform: rotate(15deg);
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;




const CardEmoji = styled.span`
  font-size: 72px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const CardSubtitle = styled.p`
  font-size: 24px;
  margin: 0;
  opacity: 0.9;
  text-align: left;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 11px;
    text-align: center;
    line-height: 1.2;
  }
`;

const FrontContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
  }
`;

const FlipContainer = styled.div`
  perspective: 1000px;
  width: 100%;
  height: 7rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.02);
  }
  
  @media (max-width: 768px) {
    height: 7rem;
    width: 110px;
    flex-shrink: 0;
    
    &:hover {
      transform: none;
    }
  }
`;

const Flipper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  ${(props) =>
    props.flipped &&
    css`
      transform: rotateY(180deg);
    `}
`;

const CardFace = css`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 0.75rem;
`;
const RightContent = styled.div`
  position: relative;
  z-index: 1;
  color: white;
`;

const Front = styled.div`
  ${CardFace}
`;

const Back = styled.div`
  ${CardFace}
  transform: rotateY(180deg);
`;

const StayUntamed = styled.div`
  h2 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 16px;
    color: white;
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 20px;
      margin-bottom: 8px;
    }
  }

  p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const CloseButton = styled.button`
  position: fixed;
  right: 6%;
  top: 5%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 18px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  
  @media (min-width: 768px) {
    position: absolute;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const Logo = styled.div`
  margin-bottom: 32px;
  
  img {
    height: 36px;
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
    
    img {
      height: 28px;
    }
  }
`;

const Title = styled.h2`
  font-size: 24px;
  color: white;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledInput = styled.input`
  background: rgba(0, 0, 0, 0.2);;
  border: 1px solid #272B30;
  border-radius: 12px;
  color: white;
  padding: 12px 16px;
  width: 100%;
  font-size: 15px;

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 13px;
    border-radius: 8px;
  }

  &::placeholder {
    color: #fff;
  }

  &:focus {
    outline: none;
    border-color: #25ee89;
  }
`;

const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordToggle = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
`;

const ForgotPassword = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  text-align: right;
  display: block;
  margin-top: -12px;
  
  @media (max-width: 768px) {
    font-size: 12px;
    margin-top: -8px;
  }
  
  &:hover {
    color: #25ee89;
  }
`;

const SignInButton = styled.button`
  background: #25ee89;
  border: none;
  border-radius: 12px;
  color: black !important;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 15px;
  width: 100%;
  cursor: pointer;
  margin-top: 12px;

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 14px;
    margin-top: 8px;
    border-radius: 8px;
  }

  &:hover {
    background-color: #00A06D;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;
  color: #fff;
  font-size: 14px;
  
  &::before, &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #272B30;
    margin: 0 16px;
  }

  @media (max-width: 768px) {
    margin: 16px 0;
    font-size: 12px;
  }
`;

const SocialLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

const SocialButton = styled.button`
  background: #292d2e;
  border: 1px solid #272B30;
  border-radius: 12px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
  
  &:hover {
    background: #191B1D;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: #fff;
  }
`;

const SignUpPrompt = styled.div`
  text-align: center;
  margin-top: 24px;
  color: #fff;
  font-size: 14px;

  @media (max-width: 768px) {
    margin-top: 16px;
    font-size: 12px;
  }

  a {
    color: #25ee89;
    text-decoration: none;
    font-weight: 600;
    margin-left: 8px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ModalClose = styled.div`
 display:none;
  @media (max-width: 768px) {
  display:flex;
   height:30px;
   width:30px;
   justify-content:center;
   align-items:center;
   border-radius:20%;
   background-color:#2D6A4D;
   position:absolute;
   padding:12px;
   top:-550px;;
   left:299px;
   z-index:9999;

  }
`;

const StyledSignInButton = styled.div`
  font-size: 14px;
  color: #fff !important;
  background-color: transparent;
  border: 1px solid  #25ee89;
  border-radius: 10px;
  padding: 7px 14px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 13px;
    padding: 6px 12px;
    border-radius: 8px;
  }
`;

// Wrapper component to use hooks in class component
const LoginWithNotifications = (props) => {
  const { notify } = useGlassyNotifications();
  return <Login {...props} notify={notify} />;
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            effect: 'zoomIn',
            username: '',
            password: '',
            email: '',
            submitted: false,
            disabled: false,
            status: false,
            forgetPage: false,
            twoFactorCode: '',
            tempLoginData: null,
            showTwoFactorModal: false,
            showReset2FAModal: false,
            reset2FAIdentifier: '',
            reset2FAOTP: '',
            reset2FAStep: 'identifier', // 'identifier' or 'otp'
            flipped: Array(3).fill(false),
        };

         this.cards = [
            {
                img: '/assets/images/avatar/sport_bonus.png',
                title: '100% up to 1 BTC',
                subtitle: 'Check sports bonus',
                bg: 'linear-gradient(90deg, rgba(240, 156, 6, 0.3), rgba(30, 35, 40, 0.9))'
            },
            {
                img: '/assets/images/avatar/casino_bonus.png',
                title: 'Up to 4 BTC + 100 FS',
                subtitle: 'Check casino package',
                bg: 'linear-gradient(135deg, rgb(245, 158, 11) 0%, rgb(14 0 0) 100%)'
            },
            {
                img: '/assets/images/avatar/later.png',
                title: 'Enjoy the game',
                subtitle: 'Claim bonus later',
                bg: 'linear-gradient(90deg, rgba(240, 156, 6, 0.3), rgba(30, 35, 40, 0.9))'
            }
        ];
    }


   
  handleInputEmailChange = (e) => {
      this.setState({ email: e.target.value });
  }

  handleSubmitForgot = (e) => {
    e.preventDefault();
    const { t } = this.props;
  
    if (!isEmail(this.state.email)) {
      this.props.notify({
        message: t ? t('please_enter_valid_email_address') : 'Please enter a valid email address',
        type: 'warning',
        position: 'top-center'
      });
      return;
    }
  
    this.setState({ disabled: true });
    socket.emit(C.RESET_PASSWORD, encode({ email: this.state.email }));
  };
resetPassword = (data) => {
  const { t } = this.props;
  const response = data;

  this.setState({ disabled: false });

  if (response.status) {
       this.setState({email:""});
       this.setState({ forgetPage: !this.state.forgetPage });
      this.props.notify({
        message: 'Password reset link has been sent to your email',
        type: 'success',
        position: 'top-center'
      });
  } else {
      this.props.notify({
        message: t ? t('this emails not registred on our system') : 'This email is not registered in our system',
        type: 'warning',
        position: 'top-center'
      });
  }
}

  


    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    }

    componentDidMount() {
      socket.on(C.LOGIN_USER, data => this.handleLoginResponse(decode(data)));
      console.log('Setting up RESET_PASSWORD listener');
      socket.on(C.RESET_PASSWORD, (data) => {
        console.log('Received RESET_PASSWORD response:', data);
        const decodedData = decode(data);
        console.log('Decoded data:', decodedData);
        this.resetPassword(decodedData);
      });
        Event.on('login_form', () => {
            this.handleShow();
        });
    }

    componentWillUnmount() {
      // Clear any pending login safety timeout to avoid setState on an
      // unmounted component.
      if (this.loginTimeout) {
        clearTimeout(this.loginTimeout);
        this.loginTimeout = null;
      }
    }

 

    check2FAStatus = async (uid) => {
      try {
          const response = await fetch(`${API}/2fa/status/${uid}`);
          const data = await response.json();
          return data.isEnabled;
      } catch (error) {
          console.error('Error checking 2FA status:', error);
          return false;
      }
  };
  handleReset2FAModalShow = () => {
    this.setState({ showReset2FAModal: true });
};

handleReset2FAModalClose = () => {
    this.setState({ 
        showReset2FAModal: false, 
        reset2FAIdentifier: '', 
        showOTPInputModal: false, 
        reset2FAOTP: '',
        disabled: false 
    });
};

handleReset2FAIdentifierChange = (e) => {
    this.setState({ reset2FAIdentifier: e.target.value });
};

handleReset2FASubmit = async (e) => {
    e.preventDefault();
    const { reset2FAIdentifier } = this.state;

    if (!reset2FAIdentifier) {
        this.props.notify({
            message: 'Please enter your email or username',
            type: 'warning',
            position: 'top-center'
        });
        return;
    }

    this.setState({ disabled: true });

    try {
        const response = await fetch(`${API}/email/2fa/reset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ identifier: reset2FAIdentifier })
        });
        const data = await response.json();

        if (data.success) {
            this.setState({ 
                showOTPInputModal: true,
                disabled: false
            });
            this.props.notify({
                message: 'OTP sent to your email',
                type: 'success',
                position: 'top-center'
            });
        } else {
            this.setState({ disabled: false });
            this.props.notify({
                message: data.error,
                type: 'error',
                position: 'top-center'
            });
        }
    } catch (error) {
        this.setState({ disabled: false });
        this.props.notify({
            message: 'Failed to send OTP',
            type: 'error',
            position: 'top-center'
        });
    }
};

handleReset2FAOTPChange = (e) => {
    this.setState({ reset2FAOTP: e.target.value });
};

handleReset2FAOTPSubmit = async (e) => {
    e.preventDefault();
    const { reset2FAIdentifier, reset2FAOTP } = this.state;

    if (!reset2FAOTP) {
        this.props.notify({
            message: 'Please enter the OTP',
            type: 'warning',
            position: 'top-center'
        });
        return;
    }

    this.setState({ disabled: true });

    try {
        const response = await fetch(`${API}/email/2fa/reset-verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                identifier: reset2FAIdentifier,
                otp: reset2FAOTP
            })
        });
        const data = await response.json();

        if (data.success) {
            this.setState({
                showReset2FAModal: false,
                showOTPInputModal: false,
                reset2FAIdentifier: '',
                reset2FAOTP: '',
                showTwoFactorInput: false,
                twoFactorCode: '',
                tempLoginData: null,
                disabled: false
            });
            this.props.notify({
                message: '2FA has been reset successfully',
                type: 'success',
                position: 'top-center'
            });
        } else {
            this.setState({ disabled: false });
            this.props.notify({
                message: data.error,
                type: 'error',
                position: 'top-center'
            });
        }
    } catch (error) {
        this.setState({ disabled: false });
        this.props.notify({
            message: 'Failed to verify OTP',
            type: 'error',
            position: 'top-center'
        });
    }
};
  handleLoginResponse = async (data) => {
    console.log('Received login response:', data);

    // Response arrived — cancel the safety timeout.
    if (this.loginTimeout) {
      clearTimeout(this.loginTimeout);
      this.loginTimeout = null;
    }

    if (data.status === true) {
      console.log('Login successful, checking 2FA status');
      try {
        const is2FAEnabled = await this.check2FAStatus(data.uid);
        console.log('2FA status:', is2FAEnabled);
        
        if (is2FAEnabled) {
          this.setState({
            showTwoFactorInput: true,
            tempLoginData: data,
            disabled: false,
            submitted: false
          });
        } else {
          this.setLogin(data);
        }
      } catch (error) {
        console.error('Error during 2FA check:', error);
        this.setState({ submitted: false, disabled: false });
        this.props.notify({
            message: 'Error verifying account security',
            type: 'error',
            position: 'top-center'
        });
      }
    } else {
      console.log('Login failed:', data.status);
      this.setState({ submitted: false, disabled: false });
      this.props.notify({
        message: data.status,
        type: 'error',
        position: 'top-center'
      });
    }
  };
    setLogin = (data) => {
        if (data.status === true) {
            this.props.notify({
                title: 'Welcome Back!',
                message: 'Login successful! Redirecting...',
                type: 'success',
                position: 'top-center'
            });
            Cookies.set("session", data.token, { expires: 14 });
            Cookies.set("uid",data.uid);
            storage.setKey('logged', true);
            storage.setKey('token', data.token);
            storage.setKey('name', data.name);
            storage.setKey('avatar', data.avatar);
            storage.setKey('email', data.email);
            storage.setKey('credit', data.credit);
            storage.setKey('room', data.room);
            storage.setKey('friends', data.friends);
            storage.setKey('country',data.country);
            localStorage.setItem('showLoginSuccessModal', 'true');
            wait(500).then(() => {
                window.location.reload();
            });

        } else {
            this.setState({ submitted: false, disabled: false });
            this.props.notify({
                message: data.status,
                type: 'error',
                position: 'top-center'
            });
        }
    };
    handleTwoFactorSubmit = async (e) => {
      e.preventDefault();
      const { twoFactorCode, tempLoginData } = this.state;

      if (!twoFactorCode) {
          this.props.notify({
              message: 'Please enter verification code',
              type: 'error',
              position: 'top-center'
          });
          return;
      }

      this.setState({ disabled: true });

      try {
          const response = await fetch(`${API}/2fa/verify`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  uid: tempLoginData.uid,
                  token: twoFactorCode
              })
          });
          const data = await response.json();
          if (data.success) {
              this.setLogin({
                  ...tempLoginData,
                  status: true
              });
          } else {
              this.setState({ 
                  disabled: false,
                  submitted: false 
              });
              this.props.notify({
                  message: 'Invalid verification code',
                  type: 'error',
                  position: 'top-center'
              });
          }
      } catch (error) {
          this.setState({ 
              disabled: false,
              submitted: false 
          });
          this.props.notify({
              message: 'Failed to verify code',
              type: 'error',
              position: 'top-center'
          });
      }
  };

    // Flip card methods
  handleFlip = (index) => {
      const newFlipped = [...this.state.flipped];
      newFlipped[index] = !newFlipped[index];
      if (index + 1 < this.cards.length) {
          newFlipped[index + 1] = !newFlipped[index + 1];
      }
      this.setState({ flipped: newFlipped });
  };
    handleShow = () => {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    handleClose = () => {
        this.setState({ 
            show: false, 
            effect: 'zoomOut', 
            disabled: false, 
            status: false, 
            submitted: false,
            forgetPage: false 
        });
    }

    handleSubmit = async (e) => {
      e.preventDefault();
      this.setState({ submitted: true, disabled: true, status: 'Please wait' });
      
      const { username, password } = this.state;
      
      if (!(username && password)) {
        console.log('Missing username or password');
        this.setState({ disabled: false, status: false });
        return;
      }
      
      const name = username.toLowerCase();
      console.log('Attempting login for:', name);

      // If the socket is not connected, don't leave the button stuck on
      // "Signing in..." forever. Tell the user and reset immediately.
      if (!socket || socket.connected === false) {
        console.warn('Socket not connected, attempting to reconnect...');
        try { socket && socket.connect && socket.connect(); } catch (e) {}
      }

      // Safety timeout: if no login response comes back (slow network,
      // websocket blocked, server unreachable), reset the button so the
      // user can retry instead of being stuck forever.
      if (this.loginTimeout) clearTimeout(this.loginTimeout);
      this.loginTimeout = setTimeout(() => {
        // Only fire if we are still waiting for a response.
        if (this.state.disabled && !this.state.showTwoFactorInput) {
          this.setState({ submitted: false, disabled: false, status: false });
          this.props.notify({
            message: 'Connection timed out. Please check your internet and try again.',
            type: 'error',
            position: 'top-center'
          });
        }
      }, 15000);

      wait(200).then(() => {
        const payload = {
          username: name,
          password: password,
          recaptcha: 'google'
        };
        console.log('Emitting login data:', payload);
        socket.emit(C.LOGIN_USER, encode(payload));
      });
    }
    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    signup = (e) => {
        e.preventDefault();
        this.handleClose();
        Event.emit('register_form');
    }

    forgetPass = (e) => {
        e.preventDefault();
        this.setState({ forgetPage: !this.state.forgetPage });
    };
    render() {
      const { 
          show, 
          username, 
          password, 
          disabled, 
          forgetPage,
          showTwoFactorInput,
          twoFactorCode,
          loading,
          showReset2FAModal,
          reset2FAIdentifier,
          showOTPInputModal,
          reset2FAOTP
      } = this.state;
  
      return (
          <>
              <StyledSignInButton onClick={this.handleShow}>
                  Sign in
              </StyledSignInButton>
              <StyledModal
                  size="md"
                  centered
                  show={show}
                  onHide={this.handleClose}
                  aria-labelledby="login-modal"
                  className={`animated ${this.state.effect}`}
              >
                  <CloseButton onClick={this.handleClose}>×</CloseButton>
                   <RightSection>
                     
                      {/* Logo for mobile, flip cards for desktop */}
                      <MobileLogo>
                        <img src="/assets/images/lg.png" alt="bkk07" style={{ width: '220px', height: 'auto' }} />
                      </MobileLogo>
                      <FlipCardsContainer>
                          {this.cards.map((card, i) => (
                              <FlipContainer key={i} onClick={() => this.handleFlip(i)}>
                                  <Flipper flipped={this.state.flipped[i]}>
                                      <Front style={{ 
                                          background: card.bg, 
                                          borderRadius: '12px', 
                                          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                                          padding: '16px', 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'center', 
                                          color: 'white' 
                                      }}>
                                          <FrontContent>
                                              {card.img.startsWith('/') ? (
                                                  <CardImage src={card.img} alt="bonus" />
                                              ) : (
                                                  <CardEmoji>{card.img}</CardEmoji>
                                              )}
                                              <CardSubtitle>{card.subtitle}</CardSubtitle>
                                          </FrontContent>
                                      </Front>
                                      <Back style={{ 
                                          background: card.bg, 
                                          borderRadius: '12px', 
                                          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                                          padding: '16px', 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'center', 
                                          color: 'white' 
                                      }}>
                                          <div style={{ textAlign: 'center' }}>
                                              <Title style={{ fontSize: '18px', margin: 0, fontWeight: '600', fontFamily: "'Montserrat', sans-serif" }}>{card.title}</Title>
                                          </div>
                                      </Back>
                                  </Flipper>
                              </FlipContainer>
                          ))}
                      </FlipCardsContainer>
                  </RightSection>
                  <LeftSection>
                      {showTwoFactorInput ? (
                          // 2FA Verification Form
                          <>
                              <Title>Two-Factor Authentication</Title>
                              <StyledForm onSubmit={this.handleTwoFactorSubmit}>
                                  <InputWrapper>
                                      <StyledInput
                                          type="text"
                                          name="twoFactorCode"
                                          value={twoFactorCode}
                                          onChange={(e) => this.setState({ 
                                              twoFactorCode: e.target.value 
                                          })}
                                          placeholder="Enter verification code"
                                      />
                                  </InputWrapper>
                                  <SignInButton type="submit" disabled={disabled}>
                                      {disabled ? 'Verifying...' : 'Verify Code'}
                                  </SignInButton>
                                  <ForgotPassword href="#" onClick={this.handleReset2FAModalShow}>
                                      Lost access to 2FA? Reset it
                                  </ForgotPassword>
                              </StyledForm>
                          </>
                      ) : (
                          // Original Login Form or Forgot Password Form
                          !forgetPage ? (
                              <>
                                  <Title>Sign In</Title>
                                  <StyledForm onSubmit={this.handleSubmit}>
                                      <InputWrapper>
                                          <StyledInput
                                              type="text"
                                              name="username"
                                              value={username}
                                              onChange={this.handleInputChange}
                                              placeholder="Username or email"
                                          />
                                      </InputWrapper>
                                      <InputWrapper>
                                          <PasswordWrapper>
                                              <StyledInput
                                                  type={this.state.showPassword ? "text" : "password"}
                                                  name="password"
                                                  value={password}
                                                  onChange={this.handleInputChange}
                                                  placeholder="Password"
                                              />
                                              <PasswordToggle 
                                                  type="button" 
                                                  onClick={this.togglePasswordVisibility}
                                              >
                                                  {this.state.showPassword ? (
                                                      <svg viewBox="0 0 24 24" width="20" height="20">
                                                          <path fill="currentColor" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.20-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                                                      </svg>
                                                  ) : (
                                                      <svg viewBox="0 0 24 24" width="20" height="20">
                                                          <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                                                      </svg>
                                                  )}
                                              </PasswordToggle>
                                          </PasswordWrapper>
                                      </InputWrapper>
                                      <ForgotPassword href="#" onClick={this.forgetPass}>
                                          Forgot your password?
                                      </ForgotPassword>
                                      <SignInButton type="submit" disabled={disabled}>
                                          {disabled ? 'Signing in...' : 'Sign In'}
                                      </SignInButton>
                                  </StyledForm>
                                  <Divider>or continue with</Divider>
                                  <SocialLoginContainer>
                                      <Google />
                                  </SocialLoginContainer>
                                  <SignUpPrompt>
                                      Don't have an account?
                                      <a href="#" onClick={this.signup}>Sign up</a>
                                  </SignUpPrompt>
                              </>
                          ) : (
                              // Forgot Password Form
                              <StyledForm onSubmit={this.handleSubmitForgot}>
                                  <Title>Reset Password</Title>
                                  <InputWrapper>
                                      <StyledInput
                                          type="email"
                                          name="email"
                                          placeholder="Enter your email"
                                          onChange={this.handleInputEmailChange}
                                      />
                                  </InputWrapper>
                                  <SignInButton type="submit" disabled={disabled}>
                                      {disabled ? 'Loading...' : 'Reset Password'}
                                  </SignInButton>
                                  <SignUpPrompt>
                                      Remember your password?
                                      <a href="#" onClick={this.forgetPass}>Sign in</a>
                                  </SignUpPrompt>
                              </StyledForm>
                          )
                      )}
                  </LeftSection>
              </StyledModal>
  
              {/* 2FA Reset Modal */}
              <StyledModal
                  size="md"
                  centered
                  show={showReset2FAModal}
                  onHide={this.handleReset2FAModalClose}
                  aria-labelledby="reset-2fa-modal"
                  className={`animated ${this.state.effect}`}
              >
                  <CloseButton onClick={this.handleReset2FAModalClose}>×</CloseButton>
                  <LeftSection>
                      {showOTPInputModal ? (
                          <>
                              <Title>Verify OTP</Title>
                              <StyledForm onSubmit={this.handleReset2FAOTPSubmit}>
                                  <InputWrapper>
                                      <StyledInput
                                          type="text"
                                          name="reset2FAOTP"
                                          value={reset2FAOTP}
                                          onChange={this.handleReset2FAOTPChange}
                                          placeholder="Enter OTP"
                                      />
                                  </InputWrapper>
                                  <SignInButton type="submit" disabled={disabled}>
                                      {disabled ? 'Verifying...' : 'Verify OTP'}
                                  </SignInButton>
                              </StyledForm>
                          </>
                      ) : (
                          <>
                              <Title>Reset 2FA</Title>
                              <StyledForm onSubmit={this.handleReset2FASubmit}>
                                  <InputWrapper>
                                      <StyledInput
                                          type="text"
                                          name="reset2FAIdentifier"
                                          value={reset2FAIdentifier}
                                          onChange={this.handleReset2FAIdentifierChange}
                                          placeholder="Enter your email or username"
                                      />
                                  </InputWrapper>
                                  <SignInButton type="submit" disabled={disabled}>
                                      {disabled ? 'Sending...' : 'Send OTP'}
                                  </SignInButton>
                              </StyledForm>
                          </>
                      )}
                  </LeftSection>
              </StyledModal>
          </>
      );
  }
  //   render() {
  //     const { 
  //         show, 
  //         username, 
  //         password, 
  //         disabled, 
  //         forgetPage,
  //         showTwoFactorInput,
  //         twoFactorCode ,
  //         loading,
  //         showReset2FAModal,
  //       reset2FAIdentifier,
  //       showOTPInputModal,
  //       reset2FAOTP
  //     } = this.state;
    
  //     return (
  //         <>
  //             <StyledSignInButton onClick={this.handleShow}>
  //                 Sign in
  //             </StyledSignInButton>
  //             <StyledModal
  //                 size="md"
  //                 centered
  //                 show={show}
  //                 onHide={this.handleClose}
  //                 aria-labelledby="login-modal"
  //                 className={`animated ${this.state.effect}`}
  //             >
  //                 <CloseButton onClick={this.handleClose}>×</CloseButton>
  //                 <RightSection>
  //                     <RightContent>
  //                         <ModalClose onClick={this.handleClose}>x</ModalClose>
  //                     </RightContent>
  //                     <StayUntamed />
  //                 </RightSection>
  //                 <LeftSection>
  //                     {showTwoFactorInput ? (
  //                         // 2FA Verification Form
  //                         <>
  //                             <Title>Two-Factor Authentication</Title>
  //                             <StyledForm onSubmit={this.handleTwoFactorSubmit}>
  //                                 <InputWrapper>
  //                                     <StyledInput
  //                                         type="text"
  //                                         name="twoFactorCode"
  //                                         value={twoFactorCode}
  //                                         onChange={(e) => this.setState({ 
  //                                             twoFactorCode: e.target.value 
  //                                         })}
  //                                         placeholder="Enter verification code"
  //                                     />
  //                                 </InputWrapper>
  //                                 <SignInButton type="submit" disabled={disabled}>
  //                                     {disabled ? 'Verifying...' : 'Verify Code'}
  //                                 </SignInButton>
  //                             </StyledForm>
  //                         </>
  //                     ) : (
  //                         // Original Login Form
  //                         !forgetPage ? (
  //                             <>
  //                                 <Title>Sign In</Title>
  //                                 <StyledForm onSubmit={this.handleSubmit}>
  //                                     <InputWrapper>
  //                                         <StyledInput
  //                                             type="text"
  //                                             name="username"
  //                                             value={username}
  //                                             onChange={this.handleInputChange}
  //                                             placeholder="Username or email"
  //                                         />
  //                                     </InputWrapper>
  //                                     <InputWrapper>
  //                                         <PasswordWrapper>
  //                                             <StyledInput
  //                                                 type={this.state.showPassword ? "text" : "password"}
  //                                                 name="password"
  //                                                 value={password}
  //                                                 onChange={this.handleInputChange}
  //                                                 placeholder="Password"
  //                                             />
  //                                             <PasswordToggle 
  //                                                 type="button" 
  //                                                 onClick={this.togglePasswordVisibility}
  //                                             >
  //                                                 {this.state.showPassword ? (
  //                                                     <svg viewBox="0 0 24 24" width="20" height="20">
  //                                                         <path fill="currentColor" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
  //                                                     </svg>
  //                                                 ) : (
  //                                                     <svg viewBox="0 0 24 24" width="20" height="20">
  //                                                         <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  //                                                     </svg>
  //                                                 )}
  //                                             </PasswordToggle>
  //                                         </PasswordWrapper>
  //                                     </InputWrapper>
  //                                     <ForgotPassword href="#" onClick={this.forgetPass}>
  //                                         Forgot your password?
  //                                     </ForgotPassword>
  //                                     <SignInButton type="submit" disabled={disabled}>
  //                                         {disabled ? 'Signing in...' : 'Sign In'}
  //                                     </SignInButton>
  //                                 </StyledForm>
  //                                 <Divider>or continue with</Divider>
  //                                 <SocialLoginContainer>
  //                                     <Google />
  //                                 </SocialLoginContainer>
  //                                 <SignUpPrompt>
  //                                     Don't have an account?
  //                                     <a href="#" onClick={this.signup}>Sign up</a>
  //                                 </SignUpPrompt>
  //                             </>
  //                         ) : (
  //                             // Forgot Password Form
  //                             <StyledForm onSubmit={this.handleSubmitForgot}>
  //                             <Title>Reset Password</Title>
  //                             <InputWrapper>
  //                                 <StyledInput
  //                                     type="email"
  //                                     name="email"
  //                                     placeholder="Enter your email"
  //                                     onChange={this.handleInputEmailChange}
  //                                 />
  //                             </InputWrapper>
  //                             <SignInButton type="submit" disabled={disabled}>
  //                              {disabled ? 'Loading...' : 'Reset Password'}
  //                             </SignInButton>
  //                             <SignUpPrompt>
  //                                 Remember your password?
  //                                 <a href="#" onClick={this.forgetPass}>Sign in</a>
  //                             </SignUpPrompt>
  //                         </StyledForm>
  //                         )
  //                     )}
  //                 </LeftSection>
  //             </StyledModal>
  //         </>
  //     );
  // }
}

export default LoginWithNotifications;